import request from '@/utils/request'

// 查询列表
export function listTSysBusinessOrganization (query) {
  return request({
    url: '/mdm/tSysBusinessOrganization/list',
    method: 'get',
    params: query
  })
}
// 职能类型
export function listFunctionType (query) {
  return request({
    url: '/mdm/tSysBusinessOrganization/functionType',
    method: 'get',
    params: query
  })
}
